import React, { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';

import TableContainer from '../../../../../Components/Common/TableContainer';

import { columns } from './columns';
import { useMatch } from 'react-router';
import { getInvoices } from '../../slice';

export const Invoices: React.FC = () => {
  const { invoices } = useAppSelector((state) => state.userDetails);

  const dispatch = useAppDispatch();

  const match = useMatch('/users/:id/*');
  const userId = match?.params.id;

  useEffect(() => {
    dispatch(getInvoices(Number(userId)));
  }, []);

  return (
    <>
      <TableContainer
        columns={columns}
        data={invoices || []}
        divClass='table-responsive table-card mb-1'
        tableClass='align-middle table-nowrap'
        theadClass='table-light text-muted'
      />
    </>
  );
};
